import { createContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { strapiRequest } from "../functions/axiosRequest";

export const LanguageContext=createContext();

export function LanguageProvider(props){

    const [cookies, setCookie] = useCookies();

    const defaultLang = { code: 'en' };

    const [langs, setLangs] = useState([defaultLang]);
    const [lang, setLang] = useState(defaultLang);

    useEffect(() => {
        async function getLocales(){
            const locales = await strapiRequest({
                method: 'get',
                endpoint: 'i18n/locales'
            });
            if(locales?.length) {
                setLangs(locales);
                if(cookies.lang) {
                    const savedLang = locales.find((theLang) => theLang.code === cookies.lang);
                    if(savedLang) setLang(savedLang);
                    else setLang(defaultLang);
                }
                else {
                    setLang(locales[0]);
                    setCookie('lang', locales[0].code);
                }
            }
        }
        getLocales();
    }, []);

    function updateLang(code) {
        setLang(langs.find((theLang) => theLang.code === code));
        setCookie('lang', code);
    }

    return(
        <LanguageContext.Provider 
            value={{
                langs,
                lang,
                updateLang
            }}
        >
            {props.children}
        </LanguageContext.Provider>
    );
};
